import React from 'react';
function MainHeader() {
	return (
		<>
			<nav className="navbar navbar-expand navbar-light topbar static-top">
				<div className="logo">
					<a className="logo-expanded" href="/dashboard">
						<img alt="logo" src="/icons/nitex-logo.svg" />
					</a>
				</div>
				<div className="mobile-menu-controller">
					<div className="hamburger cursor-pointer ml-3">
						<img alt="view" src="/icons/hamburger.svg" width="20px" />
					</div>
				</div>
				<div className="main-nav">
					<div className="hamburger-header justify-content-between align-items-center">
						<div className="logo">
							<a className="logo-expanded" href="/dashboard">
								<img alt="logo" src="../../public/icons/nitex-logo.svg" />
							</a>
						</div>
						<span className="close-icon cursor-pointer">
							<img alt="view" src="/icons/close-icon.svg" />
						</span>
					</div>
					<ul>
						<li className>
							<a href>Dashboard</a>
						</li>
						<li className>
							<a href>Pending requests</a>
						</li>
						<li className>
							<a href>Collections</a>
						</li>
						<li className="active">
							<a href>Nitex studio</a>
						</li>
						<li className>
							<a href>Materials</a>
						</li>
						<li className>
							<a href>Suppliers</a>
						</li>
						<li className>
							<a href>Orders</a>
						</li>
						<li className>
							<a href>CRM</a>
						</li>
						<li className>
							<a href>Costing</a>
						</li>
						{/* <li className="more-menu">
							<a>More</a>
							<div className="sub-menu" id="#subMenu">
								<ul>
									<label htmlFor>Users</label>
									<li>
										<a className href="/admins/list">
											Admins
										</a>
									</li>
									<li>
										<a className href="/clients/list">
											Clients
										</a>
									</li>
									<li>
										<a className href="/brands/list">
											Brands
										</a>
									</li>
								</ul>
								<ul>
									<label htmlFor>Services</label>
									<li>
										<a className href="/sample/all">
											Sample
										</a>
									</li>
									<li>
										<a className href="/orders/my-orders?active=ORDER_DASHBOARD">
											Orders
										</a>
									</li>
									<li>
										<a className href="/materials/view">
											Materials
										</a>
									</li>
									<li>
										<a className href="/suppliers/view">
											Suppliers
										</a>
									</li>
								</ul>
							</div>
						</li> */}
					</ul>
				</div>
				<ul className="navbar-nav ml-auto align-items-center">
					<li>
						<div className="button-add-new">
							<div className="btn-group">
								<button
									aria-expanded="false"
									aria-haspopup="true"
									className="button pr-1 dropdown-toggle dropdown-toggle-split size32"
									data-toggle="dropdown"
									type="button"
								>
									<img alt="close" src="/icons/add-round.svg" />
								</button>
								<div className="dropdown-menu dropdown-menu-right shadow">
									<a className="dropdown-item" href>
										Brand
									</a>
									<a className="dropdown-item" href>
										Client
									</a>
									<a className="dropdown-item" href="#">
										Collection
									</a>
									<a className="dropdown-item" href="#">
										Suppliers
									</a>
								</div>
							</div>
						</div>
					</li>
					<li className="nav-item ml-2 added-favorite cursor-pointer">
						<img alt="love" src="/icons/count-favorite.svg" />
					</li>
					<li
						className="nav-item notification-bell dropdown no-arrow ml-1 mr-3"
						data-original-title="Notifications"
						data-placement="top"
						data-toggle="tooltip"
						title
					>
						<button
							className="btn btn-outline-default nav-link"
							id="dropdownNotification"
							type="button"
						>
							<img alt="notification" src="/icons/notification-bell.png" />
						</button>
					</li>
					<li className="nav-item dropdown no-arrow">
						<button
							aria-expanded="false"
							aria-haspopup="true"
							className="btn btn-outline-default nav-link dropdown-toggle"
							data-toggle="dropdown"
							id="dropdownProfileButton"
							type="button"
						>
							<img
								className="img-profile rounded-circle"
								src="https://d2939dhdpmjcbe.cloudfront.net/profile_pic/2023/6/1686634855545_Mahdi_2_2.jpeg"
							/>
						</button>
						<div
							aria-labelledby="dropdownProfileButton"
							className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
						>
							<a className="dropdown-item" href="/dashboard">
								<i className="fas fa-tachometer-alt mr-2 text-gray-400 font-12" />
								Dashboard
							</a>
							<a className="dropdown-item" href="/my-profile">
								<i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
								Profile
							</a>
							<a className="dropdown-item cursor-pointer" href="#">
								<i className="fas fa-question-circle mr-2 text-gray-400" />
								Tutorials
							</a>
							<div className="dropdown-divider" />
							<a className="dropdown-item cursor-pointer">
								<i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
								Logout
							</a>
						</div>
					</li>
				</ul>
			</nav>
		</>
	);
}
export default MainHeader;
